// firebase.js
import { initializeApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = {
    apiKey: 'AIzaSyDyK-Uc8H8wu8uns5vUk0_f4VnWcRUHaJg',
    authDomain: 'holdstation-fd4c7.firebaseapp.com',
    projectId: 'holdstation-fd4c7',
    storageBucket: 'holdstation-fd4c7.firebasestorage.app',
    messagingSenderId: '509763890011',
    appId: '1:509763890011:web:59287a964e56dc9c1ac87e',
    measurementId: 'G-Z3QV6WVPNK',
};

// Khởi tạo app
const app = initializeApp(firebaseConfig);

// Remote Config
export const remoteConfig = getRemoteConfig(app);
